import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    inputsContainer: {
        display: 'flex',
        alignItems: 'center',
    },
        medium: {
        padding: '0px 0px',
        display: 'flex',
        alignItems: 'center',
        width: '97%',
        backgroundColor: '#FFF',
        marginBottom: '16px',
        color: '#949494',
    },
        label: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '13px',
        fontWeight: 'bold',
        float: 'left',
        marginBottom: '7px',
        width: '97%',
    },
        input: {
        flex: 1,
        color: '#949494',
        borderWidth: 0,
        height: '44px',
        paddingTop: '4px',
        paddingBottom: '4px',
        paddingLeft: '1%',
        fontSize: '16px',
        opacity: '100%',
        textTransform: 'uppercase',
        outline: 'none',
        borderRadius: '5px',
    },
    inputText: {
        textTransform: 'uppercase',
    },
}));
